import { render, staticRenderFns } from "./AttendanceList.vue?vue&type=template&id=ec60e266&scoped=true"
import script from "./AttendanceList.vue?vue&type=script&lang=js"
export * from "./AttendanceList.vue?vue&type=script&lang=js"
import style0 from "./AttendanceList.vue?vue&type=style&index=0&id=ec60e266&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec60e266",
  null
  
)

export default component.exports
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerDots});
